import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { gameSearchRequestSchema, type Game } from '@plathunt/types';
import { useApi } from '../app/providers.js';

/**
 * Zeigt, dass der Katalog ueber die Repository-Schicht und mit Cursor laeuft.
 * Der komplette Katalog wird nie geladen.
 */
export function Games() {
  const api = useApi();
  const [games, setGames] = useState<Game[]>([]);
  const [cursor, setCursor] = useState<string | null>(null);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api.games
      .searchGames(gameSearchRequestSchema.parse({ limit: 20 }))
      .then((page) => {
        if (cancelled) return;
        setGames(page.items);
        setCursor(page.nextCursor);
        setHasMore(page.hasMore);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [api]);

  function loadMore() {
    setLoading(true);
    api.games
      .searchGames(gameSearchRequestSchema.parse({ limit: 20, cursor }))
      .then((page) => {
        setGames((prev) => [...prev, ...page.items]);
        setCursor(page.nextCursor);
        setHasMore(page.hasMore);
      })
      .finally(() => setLoading(false));
  }

  return (
    <section>
      <h1 className="ph-screen__title">Spiele</h1>
      <div className="ph-card">
        {games.map((game) => (
          <Link key={game.id} className="ph-row" to={`/game/${game.id}`}>
            {game.title}
            <div className="ph-muted">{game.platforms.join(' · ').toUpperCase()}</div>
          </Link>
        ))}
        {games.length === 0 && !loading && <p className="ph-muted">Noch keine Einträge.</p>}
      </div>
      {loading && <p className="ph-muted">Lädt …</p>}
      {hasMore && !loading && (
        <button type="button" onClick={loadMore}>
          Mehr laden
        </button>
      )}
    </section>
  );
}
